import { IconChevronDown, IconSparkles } from "@tabler/icons-react";
import type { FC } from "react";
import type { PressEvents } from "react-aria";
import { Button as AriaButton, type SlotProps } from "react-aria-components";
import { twMerge } from "tailwind-merge";

export interface SuggestionsPillProps extends PressEvents, SlotProps {
  isLoading?: boolean;
  count: number | undefined;
}

export const SuggestionsPill: FC<SuggestionsPillProps> = (props) => {
  const { isLoading, count, ...buttonProps } = props;

  if (!isLoading && count === 0) {
    return null;
  }

  return (
    <AriaButton
      {...buttonProps}
      className={twMerge(
        "flex cursor-pointer flex-row items-center rounded-full px-1 py-0.5 text-xs font-medium",
        isLoading
          ? "animate-pulse text-purple-500"
          : "bg-purple-100 text-purple-700 hover:bg-purple-200 hover:text-purple-800",
      )}
      isPending={isLoading}
    >
      <IconSparkles
        className={twMerge(
          "size-4",
          isLoading ? "text-purple-400" : "text-purple-600",
        )}
      />
      {count !== undefined ? (
        <div className="px-1">
          {count} {count === 1 ? "suggestion" : "suggestions"}
        </div>
      ) : null}
      {!isLoading ? (
        <IconChevronDown className="size-4 text-purple-600" />
      ) : null}
    </AriaButton>
  );
};
